'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var yup = require('yup');
var _get = require('lodash/get');
var validate = require('./validate.js');
require('core-js/es6/promise');
require('core-js/es6/set');
require('google-libphonenumber');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var yup__namespace = /*#__PURE__*/_interopNamespace(yup);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var lib$1 = {exports: {}};

var lib = {exports: {}};

var hasRequiredLib;

function requireLib () {
	if (hasRequiredLib) return lib.exports;
	hasRequiredLib = 1;
	// Generated by CoffeeScript 1.10.0
	(function() {
	  var QJ, rreturn, rtrim;

	  QJ = function(selector) {
	    if (QJ.isDOMElement(selector)) {
	      return selector;
	    }
	    return document.querySelectorAll(selector);
	  };

	  QJ.isDOMElement = function(el) {
	    return el && (el.nodeName != null);
	  };

	  rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

	  QJ.trim = function(text) {
	    if (text === null) {
	      return "";
	    } else {
	      return (text + "").replace(rtrim, "");
	    }
	  };

	  rreturn = /\r/g;

	  QJ.val = function(el, val) {
	    var ret;
	    if (arguments.length > 1) {
	      return el.value = val;
	    } else {
	      ret = el.value;
	      if (typeof ret === "string") {
	        return ret.replace(rreturn, "");
	      } else {
	        if (ret === null) {
	          return "";
	        } else {
	          return ret;
	        }
	      }
	    }
	  };

	  QJ.preventDefault = function(eventObject) {
	    if (typeof eventObject.preventDefault === "function") {
	      eventObject.preventDefault();
	      return;
	    }
	    eventObject.returnValue = false;
	    return false;
	  };

	  QJ.normalizeEvent = function(e) {
	    var original;
	    original = e;
	    e = {
	      which: original.which != null ? original.which : void 0,
	      target: original.target || original.srcElement,
	      preventDefault: function() {
	        return QJ.preventDefault(original);
	      },
	      originalEvent: original,
	      data: original.data || original.detail
	    };
	    if (e.which == null) {
	      e.which = original.charCode != null ? original.charCode : original.keyCode;
	    }
	    return e;
	  };

	  QJ.on = function(element, eventName, callback) {
	    var el, i, j, len, len1, multEventName, originalCallback, ref;
	    if (element.length) {
	      for (i = 0, len = element.length; i < len; i++) {
	        el = element[i];
	        QJ.on(el, eventName, callback);
	      }
	      return;
	    }
	    if (eventName.match(" ")) {
	      ref = eventName.split(" ");
	      for (j = 0, len1 = ref.length; j < len1; j++) {
	        multEventName = ref[j];
	        QJ.on(element, multEventName, callback);
	      }
	      return;
	    }
	    originalCallback = callback;
	    callback = function(e) {
	      e = QJ.normalizeEvent(e);
	      return originalCallback(e);
	    };
	    if (element.addEventListener) {
	      return element.addEventListener(eventName, callback, false);
	    }
	    if (element.attachEvent) {
	      eventName = "on" + eventName;
	      return element.attachEvent(eventName, callback);
	    }
	    element['on' + eventName] = callback;
	  };

	  QJ.addClass = function(el, className) {
	    var e;
	    if (el.length) {
	      return (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = el.length; i < len; i++) {
	          e = el[i];
	          results.push(QJ.addClass(e, className));
	        }
	        return results;
	      })();
	    }
	    if (el.classList) {
	      return el.classList.add(className);
	    } else {
	      return el.className += ' ' + className;
	    }
	  };

	  QJ.hasClass = function(el, className) {
	    var e, hasClass, i, len;
	    if (el.length) {
	      hasClass = true;
	      for (i = 0, len = el.length; i < len; i++) {
	        e = el[i];
	        hasClass = hasClass && QJ.hasClass(e, className);
	      }
	      return hasClass;
	    }
	    if (el.classList) {
	      return el.classList.contains(className);
	    } else {
	      return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
	    }
	  };

	  QJ.removeClass = function(el, className) {
	    var cls, e, i, len, ref, results;
	    if (el.length) {
	      return (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = el.length; i < len; i++) {
	          e = el[i];
	          results.push(QJ.removeClass(e, className));
	        }
	        return results;
	      })();
	    }
	    if (el.classList) {
	      ref = className.split(' ');
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        cls = ref[i];
	        results.push(el.classList.remove(cls));
	      }
	      return results;
	    } else {
	      return el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	    }
	  };

	  QJ.toggleClass = function(el, className, bool) {
	    var e;
	    if (el.length) {
	      return (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = el.length; i < len; i++) {
	          e = el[i];
	          results.push(QJ.toggleClass(e, className, bool));
	        }
	        return results;
	      })();
	    }
	    if (bool) {
	      if (!QJ.hasClass(el, className)) {
	        return QJ.addClass(el, className);
	      }
	    } else {
	      return QJ.removeClass(el, className);
	    }
	  };

	  QJ.append = function(el, toAppend) {
	    var e;
	    if (el.length) {
	      return (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = el.length; i < len; i++) {
	          e = el[i];
	          results.push(QJ.append(e, toAppend));
	        }
	        return results;
	      })();
	    }
	    return el.insertAdjacentHTML('beforeend', toAppend);
	  };

	  QJ.find = function(el, selector) {
	    if (el instanceof NodeList || el instanceof Array) {
	      el = el[0];
	    }
	    return el.querySelectorAll(selector);
	  };

	  QJ.trigger = function(el, name, data) {
	    var ev;
	    try {
	      ev = new CustomEvent(name, {
	        detail: data
	      });
	    } catch (error) {
	      ev = document.createEvent('CustomEvent');
	      if (ev.initCustomEvent) {
	        ev.initCustomEvent(name, true, true, data);
	      } else {
	        ev.initEvent(name, true, true, data);
	      }
	    }
	    return el.dispatchEvent(ev);
	  };

	  lib.exports = QJ;

	}).call(commonjsGlobal);
	return lib.exports;
}

// Generated by CoffeeScript 1.10.0
(function() {
  var Payment, QJ, cardFromNumber, cardFromType, cards, defaultFormat, formatBackCardNumber, formatBackExpiry, formatCardNumber, formatExpiry, formatForwardExpiry, formatForwardSlash, formatMonthExpiry, hasTextSelected, luhnCheck, reFormatCardNumber, restrictCVC, restrictCardNumber, restrictCombinedExpiry, restrictExpiry, restrictMonthExpiry, restrictNumeric, restrictYearExpiry, setCardType,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  QJ = requireLib();

  defaultFormat = /(\d{1,4})/g;

  cards = [
    {
      type: 'amex',
      pattern: /^3[47]/,
      format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
      length: [15],
      cvcLength: [4],
      luhn: true
    }, {
      type: 'dankort',
      pattern: /^5019/,
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'hipercard',
      pattern: /^(384100|384140|384160|606282|637095|637568|60(?!11))/,
      format: defaultFormat,
      length: [14, 15, 16, 17, 18, 19],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'dinersclub',
      pattern: /^(36|38|30[0-5])/,
      format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
      length: [14],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'discover',
      pattern: /^(6011|65|64[4-9]|622)/,
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'jcb',
      pattern: /^35/,
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'laser',
      pattern: /^(6706|6771|6709)/,
      format: defaultFormat,
      length: [16, 17, 18, 19],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'maestro',
      pattern: /^(5018|5020|5038|6304|6703|6708|6759|676[1-3])/,
      format: defaultFormat,
      length: [12, 13, 14, 15, 16, 17, 18, 19],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'mastercard',
      pattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'unionpay',
      pattern: /^62/,
      format: defaultFormat,
      length: [16, 17, 18, 19],
      cvcLength: [3],
      luhn: false
    }, {
      type: 'visaelectron',
      pattern: /^4(026|17500|405|508|844|91[37])/,
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'elo',
      pattern: /^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|4(0[5-9]|3[0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8])|9([2-6][0-9]|7[0-8])|541|700|720|901)|651652|655000|655021)/,
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'visa',
      pattern: /^4/,
      format: defaultFormat,
      length: [13, 16, 19],
      cvcLength: [3],
      luhn: true
    }
  ];

  cardFromNumber = function(num) {
    var card, j, len;
    num = (num + '').replace(/\D/g, '');
    for (j = 0, len = cards.length; j < len; j++) {
      card = cards[j];
      if (card.pattern.test(num)) {
        return card;
      }
    }
  };

  cardFromType = function(type) {
    var card, j, len;
    for (j = 0, len = cards.length; j < len; j++) {
      card = cards[j];
      if (card.type === type) {
        return card;
      }
    }
  };

  luhnCheck = function(num) {
    var digit, digits, j, len, odd, sum;
    odd = true;
    sum = 0;
    digits = (num + '').split('').reverse();
    for (j = 0, len = digits.length; j < len; j++) {
      digit = digits[j];
      digit = parseInt(digit, 10);
      if ((odd = !odd)) {
        digit *= 2;
      }
      if (digit > 9) {
        digit -= 9;
      }
      sum += digit;
    }
    return sum % 10 === 0;
  };

  hasTextSelected = function(target) {
    var ref;
    try {
      if ((target.selectionStart != null) && target.selectionStart !== target.selectionEnd) {
        return true;
      }
      if ((typeof document !== "undefined" && document !== null ? (ref = document.selection) != null ? ref.createRange : void 0 : void 0) != null) {
        if (document.selection.createRange().text) {
          return true;
        }
      }
    } catch (error) {
    }
    return false;
  };

  reFormatCardNumber = function(e) {
    return setTimeout((function(_this) {
      return function() {
        var target, value;
        target = e.target;
        value = QJ.val(target);
        value = Payment.fns.formatCardNumber(value);
        QJ.val(target, value);
        return QJ.trigger(target, 'change');
      };
    })());
  };

  formatCardNumber = function(maxLength) {
    return function(e) {
      var card, digit, i, j, len, length, re, target, upperLength, upperLengths, value;
      digit = String.fromCharCode(e.which);
      if (!/^\d+$/.test(digit)) {
        return;
      }
      target = e.target;
      value = QJ.val(target);
      card = cardFromNumber(value + digit);
      length = (value.replace(/\D/g, '') + digit).length;
      upperLengths = [16];
      if (card) {
        upperLengths = card.length;
      }
      if (maxLength) {
        upperLengths = upperLengths.filter(function(x) {
          return x <= maxLength;
        });
      }
      for (i = j = 0, len = upperLengths.length; j < len; i = ++j) {
        upperLength = upperLengths[i];
        if (length >= upperLength && upperLengths[i + 1]) {
          continue;
        }
        if (length >= upperLength) {
          return;
        }
      }
      if (hasTextSelected(target)) {
        return;
      }
      if (card && card.type === 'amex') {
        re = /^(\d{4}|\d{4}\s\d{6})$/;
      } else {
        re = /(?:^|\s)(\d{4})$/;
      }
      if (re.test(value)) {
        e.preventDefault();
        QJ.val(target, value + ' ' + digit);
        return QJ.trigger(target, 'change');
      }
    };
  };

  formatBackCardNumber = function(e) {
    var target, value;
    target = e.target;
    value = QJ.val(target);
    if (e.meta) {
      return;
    }
    if (e.which !== 8) {
      return;
    }
    if (hasTextSelected(target)) {
      return;
    }
    if (/\d\s$/.test(value)) {
      e.preventDefault();
      QJ.val(target, value.replace(/\d\s$/, ''));
      return QJ.trigger(target, 'change');
    } else if (/\s\d?$/.test(value)) {
      e.preventDefault();
      QJ.val(target, value.replace(/\s\d?$/, ''));
      return QJ.trigger(target, 'change');
    }
  };

  formatExpiry = function(e) {
    var digit, target, val;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    target = e.target;
    val = QJ.val(target) + digit;
    if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
      e.preventDefault();
      QJ.val(target, "0" + val + " / ");
      return QJ.trigger(target, 'change');
    } else if (/^\d\d$/.test(val)) {
      e.preventDefault();
      QJ.val(target, val + " / ");
      return QJ.trigger(target, 'change');
    }
  };

  formatMonthExpiry = function(e) {
    var digit, target, val;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    target = e.target;
    val = QJ.val(target) + digit;
    if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
      e.preventDefault();
      QJ.val(target, "0" + val);
      return QJ.trigger(target, 'change');
    } else if (/^\d\d$/.test(val)) {
      e.preventDefault();
      QJ.val(target, "" + val);
      return QJ.trigger(target, 'change');
    }
  };

  formatForwardExpiry = function(e) {
    var digit, target, val;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    target = e.target;
    val = QJ.val(target);
    if (/^\d\d$/.test(val)) {
      QJ.val(target, val + " / ");
      return QJ.trigger(target, 'change');
    }
  };

  formatForwardSlash = function(e) {
    var slash, target, val;
    slash = String.fromCharCode(e.which);
    if (slash !== '/') {
      return;
    }
    target = e.target;
    val = QJ.val(target);
    if (/^\d$/.test(val) && val !== '0') {
      QJ.val(target, "0" + val + " / ");
      return QJ.trigger(target, 'change');
    }
  };

  formatBackExpiry = function(e) {
    var target, value;
    if (e.metaKey) {
      return;
    }
    target = e.target;
    value = QJ.val(target);
    if (e.which !== 8) {
      return;
    }
    if (hasTextSelected(target)) {
      return;
    }
    if (/\d(\s|\/)+$/.test(value)) {
      e.preventDefault();
      QJ.val(target, value.replace(/\d(\s|\/)*$/, ''));
      return QJ.trigger(target, 'change');
    } else if (/\s\/\s?\d?$/.test(value)) {
      e.preventDefault();
      QJ.val(target, value.replace(/\s\/\s?\d?$/, ''));
      return QJ.trigger(target, 'change');
    }
  };

  restrictNumeric = function(e) {
    var input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return e.preventDefault();
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    if (!/[\d\s]/.test(input)) {
      return e.preventDefault();
    }
  };

  restrictCardNumber = function(maxLength) {
    return function(e) {
      var card, digit, length, target, value;
      target = e.target;
      digit = String.fromCharCode(e.which);
      if (!/^\d+$/.test(digit)) {
        return;
      }
      if (hasTextSelected(target)) {
        return;
      }
      value = (QJ.val(target) + digit).replace(/\D/g, '');
      card = cardFromNumber(value);
      length = 16;
      if (card) {
        length = card.length[card.length.length - 1];
      }
      if (maxLength) {
        length = Math.min(length, maxLength);
      }
      if (!(value.length <= length)) {
        return e.preventDefault();
      }
    };
  };

  restrictExpiry = function(e, length) {
    var digit, target, value;
    target = e.target;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    if (hasTextSelected(target)) {
      return;
    }
    value = QJ.val(target) + digit;
    value = value.replace(/\D/g, '');
    if (value.length > length) {
      return e.preventDefault();
    }
  };

  restrictCombinedExpiry = function(e) {
    return restrictExpiry(e, 6);
  };

  restrictMonthExpiry = function(e) {
    return restrictExpiry(e, 2);
  };

  restrictYearExpiry = function(e) {
    return restrictExpiry(e, 4);
  };

  restrictCVC = function(e) {
    var digit, target, val;
    target = e.target;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    if (hasTextSelected(target)) {
      return;
    }
    val = QJ.val(target) + digit;
    if (!(val.length <= 4)) {
      return e.preventDefault();
    }
  };

  setCardType = function(e) {
    var allTypes, card, cardType, target, val;
    target = e.target;
    val = QJ.val(target);
    cardType = Payment.fns.cardType(val) || 'unknown';
    if (!QJ.hasClass(target, cardType)) {
      allTypes = (function() {
        var j, len, results;
        results = [];
        for (j = 0, len = cards.length; j < len; j++) {
          card = cards[j];
          results.push(card.type);
        }
        return results;
      })();
      QJ.removeClass(target, 'unknown');
      QJ.removeClass(target, allTypes.join(' '));
      QJ.addClass(target, cardType);
      QJ.toggleClass(target, 'identified', cardType !== 'unknown');
      return QJ.trigger(target, 'payment.cardType', cardType);
    }
  };

  Payment = (function() {
    function Payment() {}

    Payment.fns = {
      cardExpiryVal: function(value) {
        var month, prefix, ref, year;
        value = value.replace(/\s/g, '');
        ref = value.split('/', 2), month = ref[0], year = ref[1];
        if ((year != null ? year.length : void 0) === 2 && /^\d+$/.test(year)) {
          prefix = (new Date).getFullYear();
          prefix = prefix.toString().slice(0, 2);
          year = prefix + year;
        }
        month = parseInt(month, 10);
        year = parseInt(year, 10);
        return {
          month: month,
          year: year
        };
      },
      validateCardNumber: function(num) {
        var card, ref;
        num = (num + '').replace(/\s+|-/g, '');
        if (!/^\d+$/.test(num)) {
          return false;
        }
        card = cardFromNumber(num);
        if (!card) {
          return false;
        }
        return (ref = num.length, indexOf.call(card.length, ref) >= 0) && (card.luhn === false || luhnCheck(num));
      },
      validateCardExpiry: function(month, year) {
        var currentTime, expiry, prefix, ref, ref1;
        if (typeof month === 'object' && 'month' in month) {
          ref = month, month = ref.month, year = ref.year;
        } else if (typeof month === 'string' && indexOf.call(month, '/') >= 0) {
          ref1 = Payment.fns.cardExpiryVal(month), month = ref1.month, year = ref1.year;
        }
        if (!(month && year)) {
          return false;
        }
        month = QJ.trim(month);
        year = QJ.trim(year);
        if (!/^\d+$/.test(month)) {
          return false;
        }
        if (!/^\d+$/.test(year)) {
          return false;
        }
        month = parseInt(month, 10);
        if (!(month && month <= 12)) {
          return false;
        }
        if (year.length === 2) {
          prefix = (new Date).getFullYear();
          prefix = prefix.toString().slice(0, 2);
          year = prefix + year;
        }
        expiry = new Date(year, month);
        currentTime = new Date;
        expiry.setMonth(expiry.getMonth() - 1);
        expiry.setMonth(expiry.getMonth() + 1, 1);
        return expiry > currentTime;
      },
      validateCardCVC: function(cvc, type) {
        var ref, ref1;
        cvc = QJ.trim(cvc);
        if (!/^\d+$/.test(cvc)) {
          return false;
        }
        if (type && cardFromType(type)) {
          return ref = cvc.length, indexOf.call((ref1 = cardFromType(type)) != null ? ref1.cvcLength : void 0, ref) >= 0;
        } else {
          return cvc.length >= 3 && cvc.length <= 4;
        }
      },
      cardType: function(num) {
        var ref;
        if (!num) {
          return null;
        }
        return ((ref = cardFromNumber(num)) != null ? ref.type : void 0) || null;
      },
      formatCardNumber: function(num) {
        var card, groups, ref, upperLength;
        card = cardFromNumber(num);
        if (!card) {
          return num;
        }
        upperLength = card.length[card.length.length - 1];
        num = num.replace(/\D/g, '');
        num = num.slice(0, upperLength);
        if (card.format.global) {
          return (ref = num.match(card.format)) != null ? ref.join(' ') : void 0;
        } else {
          groups = card.format.exec(num);
          if (groups == null) {
            return;
          }
          groups.shift();
          groups = groups.filter(function(n) {
            return n;
          });
          return groups.join(' ');
        }
      }
    };

    Payment.restrictNumeric = function(el) {
      return QJ.on(el, 'keypress', restrictNumeric);
    };

    Payment.cardExpiryVal = function(el) {
      return Payment.fns.cardExpiryVal(QJ.val(el));
    };

    Payment.formatCardCVC = function(el) {
      Payment.restrictNumeric(el);
      QJ.on(el, 'keypress', restrictCVC);
      return el;
    };

    Payment.formatCardExpiry = function(el) {
      var month, year;
      Payment.restrictNumeric(el);
      if (el.length && el.length === 2) {
        month = el[0], year = el[1];
        this.formatCardExpiryMultiple(month, year);
      } else {
        QJ.on(el, 'keypress', restrictCombinedExpiry);
        QJ.on(el, 'keypress', formatExpiry);
        QJ.on(el, 'keypress', formatForwardSlash);
        QJ.on(el, 'keypress', formatForwardExpiry);
        QJ.on(el, 'keydown', formatBackExpiry);
      }
      return el;
    };

    Payment.formatCardExpiryMultiple = function(month, year) {
      QJ.on(month, 'keypress', restrictMonthExpiry);
      QJ.on(month, 'keypress', formatMonthExpiry);
      return QJ.on(year, 'keypress', restrictYearExpiry);
    };

    Payment.formatCardNumber = function(el, maxLength) {
      Payment.restrictNumeric(el);
      QJ.on(el, 'keypress', restrictCardNumber(maxLength));
      QJ.on(el, 'keypress', formatCardNumber(maxLength));
      QJ.on(el, 'keydown', formatBackCardNumber);
      QJ.on(el, 'keyup blur', setCardType);
      QJ.on(el, 'paste', reFormatCardNumber);
      QJ.on(el, 'input', reFormatCardNumber);
      return el;
    };

    Payment.getCardArray = function() {
      return cards;
    };

    Payment.setCardArray = function(cardArray) {
      cards = cardArray;
      return true;
    };

    Payment.addToCardArray = function(cardObject) {
      return cards.push(cardObject);
    };

    Payment.removeFromCardArray = function(type) {
      var key, value;
      for (key in cards) {
        value = cards[key];
        if (value.type === type) {
          cards.splice(key, 1);
        }
      }
      return true;
    };

    return Payment;

  })();

  lib$1.exports = Payment;

  commonjsGlobal.Payment = Payment;

}).call(commonjsGlobal);

var libExports = lib$1.exports;
var payment = /*@__PURE__*/getDefaultExportFromCjs(libExports);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var FIELD_VALIDATORS = {
  firstName: {
    type: 'string',
    validators: [{
      type: 'required',
      message: 'Please enter your first name'
    }]
  },
  lastName: {
    type: 'string',
    validators: [{
      type: 'required',
      message: 'Please enter your last name'
    }]
  },
  dob: {
    type: 'string',
    validators: [{
      type: 'required',
      message: 'Please enter your date of birth'
    }, {
      type: 'test',
      message: 'Please enter a valid day between 01 and 31',
      // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
      fn: function fn(value) {
        if (!value) {
          return;
        }

        var day = _get__default["default"](value.split('/'), '[0]', '').split(' ').join('');

        return day ? /^0[1-9]|[12][0-9]|3[01]$/.test(day) : true;
      }
    }, {
      type: 'test',
      message: 'Please enter a valid month between 01 and 12',
      // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
      fn: function fn(value) {
        if (!value) {
          return;
        }

        var month = _get__default["default"](value.split('/'), '[1]', '');

        return month ? /^(0[1-9]|1[012])$/.test(month) : true;
      }
    }, {
      type: 'test',
      message: 'Please enter a valid year',
      // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
      fn: function fn(value) {
        if (!value) {
          return;
        }

        var year = _get__default["default"](value.split('/'), '[2]', '');

        return year ? /^[0-9]{4}$/.test(year) : true;
      }
    }, {
      type: 'test',
      message: 'Please enter a year greater than 1900',
      // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
      fn: function fn(value) {
        if (!value) {
          return;
        }

        var year = _get__default["default"](value.split('/'), '[2]', '');

        return year ? parseInt(year, 10) >= 1900 : true;
      }
    }, {
      type: 'test',
      message: "Please enter a year before " + (new Date().getFullYear() + 1),
      // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
      fn: function fn(value) {
        if (!value) {
          return;
        }

        var year = _get__default["default"](value.split('/'), '[2]', '');

        return year ? parseInt(year, 10) <= new Date().getFullYear() : true;
      }
    }]
  },
  email: {
    type: 'string',
    validators: [{
      type: 'required',
      message: 'Please enter your email address'
    }, {
      type: 'email',
      message: 'Please enter a valid email address'
    }]
  },
  mobile: {
    type: 'string',
    validators: [{
      type: 'required',
      message: 'Please enter your mobile number'
    }, {
      type: 'test',
      message: 'Please enter a valid Australian mobile number',
      // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
      fn: function fn(value) {
        return value ? validate.isMobileNumber(value, 'AU') : true;
      }
    }]
  },
  password: {
    type: 'string',
    validators: [{
      type: 'required',
      message: 'Please enter your password'
    }]
  },
  newPassword: {
    type: 'string',
    validators: [{
      key: 'required',
      type: 'required',
      message: 'Please enter your new password'
    }, {
      key: 'min-characters',
      type: 'min',
      length: 8,
      message: 'Your password must have at least 8 characters'
    }, {
      key: 'uppercase',
      type: 'matches',
      pattern: /[A-Z]/,
      message: 'Your password must have an uppercase character'
    }, {
      key: 'number',
      type: 'matches',
      pattern: /[0-9]/,
      message: 'Your password must have a number'
    }, {
      key: 'special-character',
      type: 'matches',
      pattern: /[!@?#$%^&*)(+=._-]/,
      message: 'Your password must have a special character (e.g. ! or @ or #)'
    }]
  },
  repeatPassword: {
    type: 'string',
    validators: [{
      type: 'required',
      message: 'Enter your new password again'
    }, {
      type: 'oneOf',
      fieldName: 'password',
      message: 'This password does not match the other password'
    }]
  },
  cardNumber: {
    type: 'string',
    validators: [{
      type: 'required',
      message: 'Please enter a card number'
    }, {
      type: 'test',
      message: 'Please enter a valid card number',
      // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
      fn: function fn(value) {
        return payment.fns.validateCardNumber(value);
      }
    }]
  },
  expiry: {
    type: 'string',
    validators: [{
      type: 'required',
      message: 'Please enter an expiry'
    }, {
      type: 'test',
      message: 'Please enter a valid expiry',
      // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
      fn: function fn(value) {
        return payment.fns.validateCardExpiry(value);
      }
    }]
  },
  cvc: {
    type: 'string',
    validators: [{
      type: 'required',
      message: 'Please enter a CVC'
    }, {
      type: 'test',
      message: 'Please enter a valid CVC',
      // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
      fn: function fn(value) {
        return payment.fns.validateCardCVC(value);
      }
    }]
  }
}; // @ts-expect-error TS(7006): Parameter 'field' implicitly has an 'any' type.

var getFieldSchema = function getFieldSchema(field) {
  var key = field.key || field.name; // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message

  var defaultFieldExists = Boolean(FIELD_VALIDATORS[key]); // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message

  var fieldAttributes = defaultFieldExists ? FIELD_VALIDATORS[key] : field;
  var schema = yup__namespace;

  switch (fieldAttributes.type) {
    case 'string':
      {
        // @ts-expect-error TS(2740): Type 'StringSchema<string, Record<string, any>, st... Remove this comment to see the full error message
        schema = schema.string();
        break;
      }

    case 'object':
      {
        // @ts-expect-error TS(2740): Type 'OptionalObjectSchema<ObjectShape, Record<str... Remove this comment to see the full error message
        schema = schema.object();
        break;
      }

    case 'array':
      {
        // @ts-expect-error TS(2740): Type 'OptionalArraySchema<AnySchema<any, any, any>... Remove this comment to see the full error message
        schema = schema.array();
        break;
      }

    case 'boolean':
      {
        // @ts-expect-error TS(2740): Type 'BooleanSchema<boolean, Record<string, any>, ... Remove this comment to see the full error message
        schema = schema.boolean();
        break;
      }

    case 'date':
      {
        // @ts-expect-error TS(2740): Type 'DateSchema<Date, Record<string, any>, Date>'... Remove this comment to see the full error message
        schema = schema.date();
        break;
      }

    case 'number':
      {
        // @ts-expect-error TS(2740): Type 'NumberSchema<number, Record<string, any>, nu... Remove this comment to see the full error message
        schema = schema.number();
        break;
      }

    default:
      {
        // @ts-expect-error TS(2322): Type 'StringSchema<string, Record<string, any>, st... Remove this comment to see the full error message
        schema = schema.string();
      }
  }

  if (fieldAttributes.validators) {
    // @ts-expect-error TS(7006): Parameter 'validator' implicitly has an 'any' type... Remove this comment to see the full error message
    fieldAttributes.validators.forEach(function (validator) {
      switch (validator.type) {
        case 'required':
          {
            if (defaultFieldExists && !field.required) {
              return;
            } // @ts-expect-error TS(2339): Property 'required' does not exist on type 'typeof... Remove this comment to see the full error message


            schema = schema.required(validator.message);
            break;
          }

        case 'test':
          {
            // @ts-expect-error TS(2339): Property 'test' does not exist on type 'typeof imp... Remove this comment to see the full error message
            schema = schema.test(field.name, validator.message, validator.fn);
            break;
          }

        case 'email':
          {
            // @ts-expect-error TS(2339): Property 'email' does not exist on type 'typeof im... Remove this comment to see the full error message
            schema = schema.email(validator.message);
            break;
          }

        case 'min':
          {
            // @ts-expect-error TS(2339): Property 'min' does not exist on type 'typeof impo... Remove this comment to see the full error message
            schema = schema.min(validator.length, validator.message);
            break;
          }

        case 'matches':
          {
            // @ts-expect-error TS(2339): Property 'matches' does not exist on type 'typeof ... Remove this comment to see the full error message
            schema = schema.matches(validator.pattern, validator.message);
            break;
          }

        case 'oneOf':
          {
            // @ts-expect-error TS(2339): Property 'oneOf' does not exist on type 'typeof im... Remove this comment to see the full error message
            schema = schema.oneOf([yup__namespace.ref(validator.fieldName), null], validator.message);
            break;
          }
      }
    });
  }

  return schema;
};

var buildValidationSchema = function buildValidationSchema(fields, overrideSchema) {
  if (overrideSchema === void 0) {
    overrideSchema = {};
  }

  var schema = {};
  fields.forEach(function (field) {
    if (!field) {
      return;
    } // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message


    schema[field.name] = getFieldSchema(field);
  });
  return yup__namespace.object().shape(_objectSpread({}, schema, {}, overrideSchema));
};
/* ===== CUSTOM OVERRIDE SCHEMAS ===== */
// @ts-expect-error TS(7006): Parameter 'schema' implicitly has an 'any' type.

var validateHealthFundDate = function validateHealthFundDate(schema, _ref) {
  var cardFields = _ref.cardFields,
      fieldKey = _ref.fieldKey,
      dayKey = _ref.dayKey,
      monthKey = _ref.monthKey,
      yearKey = _ref.yearKey;
  var newSchema = schema;

  if (cardFields[dayKey]) {
    // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
    newSchema = newSchema.test(fieldKey, _get__default["default"](cardFields, dayKey + ".validation.message"), function (value) {
      var dateArray = value ? value.split('/') : [];
      var day = dateArray[0];
      return new RegExp(_get__default["default"](cardFields, dayKey + ".validation.regex")).test(day);
    });
  }

  if (cardFields[monthKey]) {
    // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
    newSchema = newSchema.test(fieldKey, _get__default["default"](cardFields, monthKey + ".validation.message"), function (value) {
      var dateArray = value ? value.split('/') : [];
      var month = dateArray[dateArray.length - 2];
      return new RegExp(_get__default["default"](cardFields, monthKey + ".validation.regex")).test(month);
    });
  }

  if (cardFields[yearKey]) {
    // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
    newSchema = newSchema.test(fieldKey, _get__default["default"](cardFields, yearKey + ".validation.message"), function (value) {
      var dateArray = value ? value.split('/') : [];
      var year = dateArray[dateArray.length - 1];
      return new RegExp(_get__default["default"](cardFields, yearKey + ".validation.regex")).test(year);
    });
  }

  return newSchema;
};

var paymentMethodValidationSchema = [{
  name: 'cardNumber'
}, {
  name: 'expiry'
}, {
  name: 'cvc'
}];
var getHealthFundAccountValidationSchema = function getHealthFundAccountValidationSchema(cardFields) {
  return _objectSpread({}, cardFields.cardNumber ? {
    cardNumber: yup__namespace.string().matches(new RegExp(_get__default["default"](cardFields, 'cardNumber.validation.regex')), _get__default["default"](cardFields, 'cardNumber.validation.message')).required("Please enter a " + _get__default["default"](cardFields, 'cardNumber.displayName', 'card number').toLowerCase())
  } : {}, {}, cardFields.membershipNumber ? {
    membershipNumber: yup__namespace.string().min(_get__default["default"](cardFields, 'membershipNumber.minLength'), _get__default["default"](cardFields, 'membershipNumber.displayName', 'membership number') + " must be at least " + _get__default["default"](cardFields, 'membershipNumber.minLength') + " numbers").max(_get__default["default"](cardFields, 'membershipNumber.maxLength', 99), _get__default["default"](cardFields, 'membershipNumber.displayName', 'membership number') + " must be less than " + _get__default["default"](cardFields, 'membershipNumber.maxLength') + " numbers").matches(new RegExp(_get__default["default"](cardFields, 'membershipNumber.validation.regex')), _get__default["default"](cardFields, 'membershipNumber.validation.message')).required("Please enter a " + _get__default["default"](cardFields, 'membershipNumber.displayName', 'membership number').toLowerCase())
  } : {}, {}, cardFields.cardRank ? {
    cardRank: yup__namespace.string().min(_get__default["default"](cardFields, 'cardRank.minLength'), _get__default["default"](cardFields, 'cardRank.displayName', 'card rank') + " must be at least " + _get__default["default"](cardFields, 'cardRank.minLength') + " numbers").max(_get__default["default"](cardFields, 'cardRank.maxLength', 99), _get__default["default"](cardFields, 'cardRank.displayName', 'card rank') + " must be less than " + _get__default["default"](cardFields, 'cardRank.maxLength') + " numbers").matches(new RegExp(_get__default["default"](cardFields, 'cardRank.validation.regex')), _get__default["default"](cardFields, 'cardRank.validation.message')).required("Please enter a " + _get__default["default"](cardFields, 'cardRank.displayName', 'card rank').toLowerCase())
  } : {}, {}, cardFields.issueDay || cardFields.issueMonth || cardFields.issueYear ? function () {
    var issueDateSchema = yup__namespace.string().required('Please enter an issue date');
    issueDateSchema = validateHealthFundDate(issueDateSchema, {
      cardFields: cardFields,
      fieldKey: 'issueDate',
      dayKey: 'issueDay',
      monthKey: 'issueMonth',
      yearKey: 'issueYear'
    });
    return {
      issueDate: issueDateSchema
    };
  }() : {}, {}, cardFields.expiryDay || cardFields.expiryMonth || cardFields.expiryYear ? function () {
    var expiryDateSchema = yup__namespace.string().required('Please enter an expiry date');
    expiryDateSchema = validateHealthFundDate(expiryDateSchema, {
      cardFields: cardFields,
      fieldKey: 'expiryDate',
      dayKey: 'expiryDay',
      monthKey: 'expiryMonth',
      yearKey: 'expiryYear'
    });
    return {
      expiryDate: expiryDateSchema
    };
  }() : {}, {}, cardFields.cardIssueNumber ? {
    cardIssueNumber: yup__namespace.string().min(_get__default["default"](cardFields, 'cardIssueNumber.minLength'), _get__default["default"](cardFields, 'cardIssueNumber.displayName', 'issue number') + " must be at least " + _get__default["default"](cardFields, 'cardIssueNumber.minLength') + " numbers").max(_get__default["default"](cardFields, 'cardIssueNumber.maxLength', 99), _get__default["default"](cardFields, 'cardIssueNumber.displayName', 'issue number') + " must be less than " + _get__default["default"](cardFields, 'cardIssueNumber.maxLength') + " numbers").matches(new RegExp(_get__default["default"](cardFields, 'cardIssueNumber.validation.regex')), _get__default["default"](cardFields, 'cardIssueNumber.validation.message')).required("Please enter a " + _get__default["default"](cardFields, 'cardIssueNumber.displayName', 'issue number').toLowerCase())
  } : {});
};

exports.FIELD_VALIDATORS = FIELD_VALIDATORS;
exports["default"] = buildValidationSchema;
exports.getHealthFundAccountValidationSchema = getHealthFundAccountValidationSchema;
exports.paymentMethodValidationSchema = paymentMethodValidationSchema;
